import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  mt: 1.25,
  width: '100%',
};
